import React from "react";
import CircularLoader from "../components/Portal/universal_components/CircularLoader/CircularLoader";

const NoPageFound = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100vw",
        height: "100vh",
      }}
    >
      <p>No Page Found</p>
    </div>
  );
};

export default NoPageFound;
